<template>

  <!-- Hero Section -->
  <div class="pb-4 heroContainer">
  </div>

  <div class="mt-4">
    <div class="d-flex justify-content-center">
      <p class="fw-bold" style="font-size: 23px; color: #252E57;">Vendor Registration</p>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <div class="col-6 p-3">
      <!-- 1st line -->
      <div class="row justify-content-center">
        <!-- Vendor Name -->
        <div class="col-md-6 position-relative mb-3">
          <label for="vendorName" class="form-label text-primary fw-semibold ms-2">Vendor Name</label><span
            class="text-danger fw-bold ms-1">*</span>
          <input type="text" id="vendorName" class="form-control w-100"
                 :class="{ 'is-valid': submitted && vendorNameIsValid, 'is-invalid': submitted && !vendorNameIsValid }"
                 placeholder="Enter Vendor Name..." v-model="vendorName">
        </div>

        <!-- Country -->
        <div class="col-md-6 position-relative mb-3">
          <label for="country" class="form-label text-primary fw-semibold ms-2">Country</label><span
            class="text-danger fw-bold ms-1">*</span>
          <div class="position-relative">
            <select id="country" class="form-select w-100"
                    :class="{ 'is-valid': submitted && countryIsValid, 'is-invalid': submitted && !countryIsValid }"
                    v-model="country" @change="getCities">
              <option value="" selected disabled>Choose Country...</option>
              <option v-for="country in countriesList" :value="country.countryRegionId">
                {{ country.shortName }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- 2nd line -->
      <div class="row justify-content-center">
        <!-- Address Line 1 -->
        <div class="col-md-6 position-relative mb-3">
          <label for="addressLine1" class="form-label text-primary fw-semibold ms-2">Address Line
            1</label><span class="text-danger fw-bold ms-1">*</span>
          <input type="text" id="addressLine1" class="form-control w-100"
                 :class="{ 'is-valid': submitted && addressLine1IsValid, 'is-invalid': submitted && !addressLine1IsValid }"
                 v-model="addressLine1" placeholder="Enter Address Line 1...">
        </div>

        <!-- Address Line 2 -->
        <div class="col-md-6 position-relative mb-3">
          <label for="addressLine2" class="form-label text-primary fw-semibold ms-2">Address Line
            2</label>
          <input type="text" id="addressLine2" class="form-control w-100"
                 :class="{ 'is-valid': submitted && addressLine2IsValid, 'is-invalid': submitted && !addressLine2IsValid }"
                 v-model="addressLine2" placeholder="Enter Address Line 2...">
        </div>
      </div>

      <!-- 3rd line -->
      <div class="row justify-content-center">
        <!-- City -->
        <div class="col-md-6 position-relative mb-3">
          <label for="city" class="form-label text-primary fw-semibold ms-2">City</label><span
            class="text-danger fw-bold ms-1">*</span>
          <select id="city" class="form-select form-control w-100"
                  :class="{ 'is-valid': submitted && cityIsValid, 'is-invalid': submitted && !cityIsValid }"
                  v-model="city">
            <option value="">Choose City...</option>
            <option v-for="city in citiesList" :value="city.name">
              {{ city.name }}
            </option>
          </select>
        </div>

        <!-- State
        <div class="col-md-4 position-relative mb-3">
          <label for="state" class="form-label text-primary fw-semibold ms-2">State</label><span
            class="text-danger fw-bold ms-1">*</span>
          <select id="state" class="form-select form-control w-100"
                  :class="{ 'is-valid': submitted && stateIsValid, 'is-invalid': submitted && !stateIsValid }"
                  v-model="state"
                  :disabled="!selectedCityStateId">
            <option value="" disabled selected>Choose State...</option>
            <option :value="selectedCityStateId">{{ selectedCityStateId }}</option>
          </select>
        </div>
        -->

        <!-- Post Box Number -->
        <div class="col-md-6 position-relative mb-3">
          <label for="postBoxNo" class="form-label text-primary fw-semibold ms-2">Post Box Number</label><span
            class="text-danger fw-bold ms-1">*</span>
          <input type="text" id="postBoxNo" class="form-control w-100"
                 :class="{ 'is-valid': submitted && postBoxNoIsValid, 'is-invalid': submitted && !postBoxNoIsValid }"
                 v-model="postBoxNo" placeholder="Enter Post Box Number...">
        </div>
      </div>

      <!-- 4th line -->
      <div class="row justify-content-center">
        <!-- Business Justifications -->
        <div class="col-md-12 position-relative mb-3">
          <label for="businessJustifications" class="form-label text-primary fw-semibold ms-2">Business
            Justifications</label><span class="text-danger fw-bold ms-1">*</span>
          <textarea id="businessJustifications" name="businessJustifications" rows="7" class="w-100"
                    :class="{ 'is-valid': submitted && businessJustificationsIsValid, 'is-invalid': submitted && !businessJustificationsIsValid }"
                    v-model="businessJustifications" placeholder="Enter Business Justifications (100 Characters Max)..."
                    maxlength="100"
                    style="border: 1px #AAAAAA solid; border-radius: 2rem; padding: 0.75rem 1.25rem;"></textarea>
        </div>
      </div>

      <!-- 5th line -->
      <div class="row justify-content-center">
        <!-- Line of Business -->
        <div class="col-md-12 position-relative mb-3">
          <label for="lineOfBusiness" class="form-label text-primary fw-semibold ms-2">Line of
            Business</label><span class="text-danger fw-bold ms-1">*</span>
          <div class="position-relative">
            <select id="lineOfBusiness" class="form-select w-100"
                    :class="{ 'is-valid': submitted && lineOfBusinessIsValid, 'is-invalid': submitted && !lineOfBusinessIsValid }"
                    v-model="lineOfBusiness">
              <option value="" selected disabled>Choose Line of Business...</option>
              <option value="ERP">ERP</option>
            </select>
          </div>
        </div>
      </div>

      <!-- 6th line -->
      <div class="row justify-content-center">
        <!-- CR Number -->
        <div class="col-md-6 position-relative mb-3">
          <label for="crNo" class="form-label text-primary fw-semibold ms-2">CR Number</label><span
            class="text-danger fw-bold ms-1">*</span>
          <input type="text" id="crNo" class="form-control w-100"
                 :class="{ 'is-valid': submitted && crNoIsValid, 'is-invalid': submitted && !crNoIsValid }"
                 v-model="crNo"
                 placeholder="Enter CR Number...">
        </div>

        <!-- CR Expiry Date -->
        <div class="col-md-6 position-relative mb-3">
          <label for="crExpiryDate" class="form-label text-primary fw-semibold ms-2">CR Expiry
            Date</label><span class="text-danger fw-bold ms-1">*</span>
          <div class="position-relative">
            <input type="date" id="crExpiryDate" class="form-control w-100"
                   :class="{ 'is-valid': submitted && crExpiryDateIsValid, 'is-invalid': submitted && !crExpiryDateIsValid }"
                   v-model="crExpiryDate"/>
          </div>
        </div>
      </div>

      <!-- 7th line -->
      <div class="row justify-content-center">
        <!-- First Name -->
        <div class="col-md-4 position-relative mb-3">
          <label for="firstName" class="form-label text-primary fw-semibold ms-2">First Name</label><span
            class="text-danger fw-bold ms-1">*</span>
          <input type="text" id="firstName" class="form-control w-100"
                 :class="{ 'is-valid': submitted && firstNameIsValid, 'is-invalid': submitted && !firstNameIsValid }"
                 v-model="firstName" placeholder="Enter First Name...">
        </div>

        <!-- Middle Name -->
        <div class="col-md-4 position-relative mb-3">
          <label for="middleName" class="form-label text-primary fw-semibold ms-2">Middle Name</label>
          <input type="text" id="middleName" class="form-control w-100"
                 :class="{ 'is-valid': submitted && middleNameIsValid, 'is-invalid': submitted && !middleNameIsValid }"
                 v-model="middleName" placeholder="Enter Middle Name...">
        </div>

        <!-- Last Name -->
        <div class="col-md-4 position-relative mb-3">
          <label for="lastName" class="form-label text-primary fw-semibold ms-2">Last Name</label><span
            class="text-danger fw-bold ms-1">*</span>
          <input type="text" id="lastName" class="form-control w-100"
                 :class="{ 'is-valid': submitted && lastNameIsValid, 'is-invalid': submitted && !lastNameIsValid }"
                 v-model="lastName" placeholder="Enter Last Name...">
        </div>
      </div>

      <!-- 8th line -->
      <div class="row justify-content-center">
        <!-- Email -->
        <div class="col-md-4 position-relative mb-3">
          <label for="email" class="form-label text-primary fw-semibold ms-2">Contact Email</label><span
            class="text-danger fw-bold ms-1">*</span>
          <input type="text" id="email" class="form-control w-100"
                 :class="{ 'is-valid': submitted && emailIsValid, 'is-invalid': submitted && !emailIsValid }"
                 v-model="email"
                 placeholder="Enter Contact Email...">
        </div>

        <!-- Country Code -->
        <div class="col-md-4 position-relative mb-3">
          <label for="countryCode" class="form-label text-primary fw-semibold ms-2">Country Code</label><span
            class="text-danger fw-bold ms-1">*</span>
          <div class="position-relative">
            <select id="countryCode" v-model="countryCode"
                    :class="{ 'is-valid': submitted && countryCodeIsValid, 'is-invalid': submitted && !countryCodeIsValid }"
                    class="form-select w-100">
              <option value="" selected disabled>Select Country Code...</option>
              <option v-for="country in countriesList" :value="country.countryRegionId">
                {{ country.shortName }}
              </option>
            </select>
          </div>
        </div>

        <!-- Contact Number -->
        <div class="col-md-4 position-relative mb-3">
          <label for="contactNo" class="form-label text-primary fw-semibold ms-2">Contact Number</label><span
            class="text-danger fw-bold ms-1">*</span>
          <input type="number" id="contactNo" class="form-control w-100"
                 :class="{ 'is-valid': submitted && contactNoIsValid, 'is-invalid': submitted && !contactNoIsValid }"
                 v-model="contactNo" placeholder="Enter Contact Number...">
        </div>
      </div>

      <!-- 9th line -->
      <div class="row justify-content-center">
        <!-- Website -->
        <div class="col-md-12 position-relative mb-3">
          <label for="website" class="form-label text-primary fw-semibold ms-2">Website</label><span
            class="text-danger fw-bold ms-1">*</span>
          <div class="position-relative">
            <input type="text" id="contactNo" class="form-control w-100"
                   :class="{ 'is-valid': submitted && websiteIsValid, 'is-invalid': submitted && !websiteIsValid }"
                   v-model="website" placeholder="Enter Website...">
          </div>
        </div>
      </div>

      <div class="d-flex d-flex justify-content-center w-100 my-3">
        <div class="col-md-4">
          <button class="btn btn-primary border-0 rounded-pill w-100" style="height: 50px; background-color: #009482;"
                  @click="Submit()">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Successfully Modal -->
  <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content custom-success-modal text-center px-4 py-3 rounded-5">

        <div class="modal-header border-0 p-0">
          <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <div class="success-icon mb-4">
            <img :src="approvedGif" alt="Animated GIF" class="img-fluid" style="height: 200px; width: 200px;"/>
          </div>
          <h5 class="fw-bold mb-3">{{ $Translate('successMessageTitle') }}</h5>
          <div class="d-inline-block">
            <p class="text-muted">
              {{ $Translate('successMessageBody1') }}
              <strong class="text-primary">eprocurement@qdb.qa</strong>
              {{ $Translate('successMessageBody2') }}
              <strong class="text-primary">4430 0560.</strong>
            </p>
          </div>

          <div class="d-flex justify-content-center">
            <button type="button" class="btn px-4 py-2 rounded-3 text-white" style="background-color: #009482;"
                    data-bs-dismiss="modal" @click="Restart">
              {{ $Translate('confirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {Modal} from 'bootstrap';

let successModal = null;

export default {
  name: 'RegistrationPage',
  data() {
    return {
      approvedGif: require('../../../assets/animations/approved.gif'),
      warningGif: require('../../../assets/animations/warning.gif'),

      requestCompany: 'usmf', //
      languageId: 'en-US', //
      organizationType: 'Organization', //
      submitted: false,

      countriesList: [],
      countryRegionId: '',
      citiesList: [],

      vendorName: '', // ABC Consulting India PVT. LTD.
      country: '',
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      postBoxNo: '',
      businessJustifications: '', // New vendor
      lineOfBusiness: '', // ERP
      crNo: '', // OrganizationNumber": 567646674467412
      crExpiryDate: '',
      firstName: '', // Ali
      middleName: '', // Mohamed
      lastName: '', // Ali
      email: '', // arashed@globalits.bh
      countryCode: '',
      contactNo: '', // 9013964193
      website: '',

      vendorNameIsValid: false,
      countryIsValid: false,
      addressLine1IsValid: false,
      addressLine2IsValid: false,
      cityIsValid: false,
      stateIsValid: false,
      postBoxNoIsValid: false,
      businessJustificationsIsValid: false,
      lineOfBusinessIsValid: false,
      crNoIsValid: false,
      crExpiryDateIsValid: false,
      firstNameIsValid: false,
      middleNameIsValid: false,
      lastNameIsValid: false,
      emailIsValid: false,
      countryCodeIsValid: false,
      contactNoIsValid: false,
      websiteIsValid: false,
    };
  },
  methods: {
    registrationRequests: async function () {
      try {
        const result = await VendorRegistrationRequests(
            this.email ?? null,
            this.crNo ?? null,
            this.requestCompany ?? null,
            this.lineOfBusiness ?? null,
            this.languageId ?? null,
            this.middleName ?? null,
            this.businessJustifications ?? null,
            this.firstName ?? null,
            this.lastName ?? null,
            this.organizationType ?? null,
            this.vendorName ?? null,
            this.contactNo?.toString() ?? null,
            this.postBoxNo ?? null,
            this.city ?? null,
            this.addressLine1 ?? null,
            this.addressLine2 ?? null,
            this.country ?? null,
            this.website ?? null,
            this.state ?? null,
            this.crExpiryDate ? new Date(this.crExpiryDate).toISOString() : null
        );
        if (result?.status === 200 && result.data?.success !== false) {
          successModal.show();
        }
      } catch (error) {
        console.log(error);
      }
    },
    Submit() {
      let valid = true;
      this.submitted = true;

      // Vendor Name Validation
      if (!this.vendorName) {
        toastr.error('Vendor Name is required.');
        this.vendorNameIsValid = false;
        valid = false;
      } else {
        this.vendorNameIsValid = true;
      }


      // Country Validation
      if (!this.country) {
        toastr.error('Country field is required.')
        this.countryIsValid = false;
        valid = false;
      } else {
        this.countryIsValid = true;
      }

      // Address Validation
      this.addressLine2IsValid = true;
      if (!this.addressLine1) {
        toastr.error('Address field is required.');
        this.addressLine1IsValid = false;
        valid = false;
      } else {
        this.addressLine1IsValid = true;
      }

      // City Validation
      if (!this.city) {
        toastr.error('City field is required.');
        this.cityIsValid = false;
        valid = false;
      } else {
        this.cityIsValid = true;
      }

      /*
      // State Validation
      if (!this.state) {
        toastr.error('State field is required.');
        this.stateIsValid = false;
        valid = false;
      } else {
        this.stateIsValid = true;
      }
      */

      // Post Box No. Validation
      if (!this.postBoxNo) {
        toastr.error('Post Box Number field is required.');
        this.postBoxNoIsValid = false;
        valid = false;
      } else {
        this.postBoxNoIsValid = true;
      }

      // Business Justification Validation
      if (!this.businessJustifications) {
        toastr.error('Business Justifications field is required.');
        this.businessJustificationsIsValid = false;
        valid = false;
      } else {
        this.businessJustificationsIsValid = true;
      }

      // Line of Business Validation
      if (!this.lineOfBusiness) {
        toastr.error('Line of Business field is required.');
        this.lineOfBusinessIsValid = false;
        valid = false;
      } else {
        this.lineOfBusinessIsValid = true;
      }

      // CR Number Validation
      if (!this.crNo) {
        toastr.error('CR Number field is required.');
        this.crNoIsValid = false;
        valid = false;
      } else {
        this.crNoIsValid = true;
      }

      // CR Expiry Date
      if (!this.crExpiryDate) {
        toastr.error('CR Expiry Date field is required.');
        this.crExpiryDateIsValid = false;
        valid = false;
      } else {
        this.crExpiryDateIsValid = true;
      }

      // First Name Validation
      if (!this.firstName) {
        toastr.error('First Name field is required.');
        this.firstNameIsValid = false;
        valid = false;
      } else {
        this.firstNameIsValid = true;
      }

      /*
      // Middle Name Validation
      if (!this.middleName) {
        toastr.error('Middle Name field is required.');
        this.middleNameIsValid = false;
        valid = false;
      } else {
        this.middleNameIsValid = true;
      }
      */
      this.middleNameIsValid = true;

      // Last Name Validation
      if (!this.lastName) {
        toastr.error('Last Name field is required.');
        this.lastNameIsValid = false;
        valid = false;
      } else {
        this.lastNameIsValid = true;
      }

      // Email
      if (!this.email) {
        toastr.error('Email field is required.');
        this.emailIsValid = false;
        valid = false;
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        toastr.warning('Please enter a valid email address.')
        this.emailIsValid = false;
        valid = false;
      } else {
        this.emailIsValid = true;
      }

      // Country Code Validation
      if (!this.countryCode) {
        toastr.error('Country Code field is required.');
        this.countryCodeIsValid = false;
        valid = false;
      } else {
        this.countryCodeIsValid = true;
      }

      // Contact Number Validation
      if (!this.contactNo) {
        toastr.error('Contact Number is required.');
        this.contactNoIsValid = false;
        valid = false;
      } else if (this.contactNo.length < 8) {
        toastr.warning('Please Enter a valid contact number.');
        this.contactNoIsValid = false;
        valid = false;
      } else {
        this.contactNoIsValid = true;
      }

      // Website Validation
      if (!this.website) {
        toastr.error('Website field is required.');
        this.websiteIsValid = false;
        valid = false;
      } else {
        this.websiteIsValid = true;
      }

      // All Validations Passed
      if (valid) {
        this.registrationRequests();
      }
    },
    Restart() {
      this.$router.push('/');
    },
    getCountries: async function () {
      try {
        this.countriesList = await GetAddressCountryRegionMaster();

        console.log(JSON.stringify(this.countriesList), null, 2);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    },
    getCities: async function () {
      try {
        this.citiesList = await GetAddressRegionCityMaster(this.country);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
  },
  watch: {
    city(newCity) {
      const selected = this.citiesList.find(c => c.name === newCity);
      this.state = selected ? selected.stateId : '';
    }
  },
  async mounted() {
    successModal = new Modal(document.getElementById('successModal'), {});
    //successModal.show();
    await this.getCountries();
  }
}
;
</script>

<style scoped>
.heroContainer {
  position: relative;
  background-image: url('../../../../src/assets/hero.jpg');
  background-size: cover;
  background-position: center;
  color: white;
  text-align: center;
  overflow: hidden;
  height: 20vh;
  border-radius: 0 0 25% 25%;
}

.hidden {
  display: none;
}

.form-control,
.form-select {
  border-radius: 2rem;
  height: 45px;
  border: 1px #AAAAAA solid;
}

input.is-invalid,
select.is-invalid,
textarea.is-invalid {
  border-color: #dc3545 !important;
}

input.is-valid,
select.is-valid,
textarea.is-valid {
  border-color: #198754 !important;
}
</style>
